import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/cityTableCustomiseSP.css";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button, DialogContainer } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import {
  MenuItem,
  Menu,
  Select,
  IconButton,
  Radio,
  TextField,
} from "@material-ui/core";
import OutlineEdit from "react-md-icon/dist/OutlineEdit";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { Col, Row } from "react-flexbox-grid";

const CityTableCustomiseSP = ({
  loading,
  mode,
  tableData,
  newTableData,
  handleUpdateNewTableData,
  handleUpdateTableData,
  cityMappingOperationSelected,
  cityMappingFilters,
  cityMappings,
  fetchCityMappings,
  customisedSP,
  assignedServiceProviderData,
  pageNum = cityMappings?.pageNo ?? 0,
  pageSize = cityMappings?.pageSize ?? 0,
  totalCount = cityMappings?.totalCount ?? 0,
}) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [serviceProviderId, setServiceProviderId] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [editCityPriceDialog, setEditCityPriceDialog] = useState({});
  const [editCityPriceDialogFormFields, setEditCityPriceDialogFormFields] =
    useState({});

  useEffect(() => {
    console.log("tableData recvd in city table: ", tableData);
    console.log("newTableData recvd in city table: ", newTableData);
  }, []);

  const allStatusList = [
    { value: 1, name: "Active" },
    { value: 2, name: "Inactive" },
  ];

  const stringToInt = (str) => {
    try {
      const num = parseInt(str, 10); // Convert string to integer with base 10
      return isNaN(num) ? null : num; // Check if conversion failed
    } catch (e) {
      return null;
    }
  };

  const getStatusName = (status) => {
    if (status == 1) {
      return "Active";
    } else if (status == 2) {
      return "Inactive";
    } else if (status == 3) {
      return "Deleted";
    }
    return "";
  };

  const checkIfPriceAsPerPlanLevel = (ele) => {
    if (ele?.originalEntity) {
      return false;
    } else {
      return (
        Boolean(ele?.priceAsPerPlan ?? false) ||
        ((ele?.serviceProviderAssignCityId ?? "") == "" &&
          (ele?.serviceProviderPlanCityId ?? "") == "") ||
        !Boolean(
          customisedSP?.cityMappingPlan?.customisedPriceEnabled ?? false
        ) ||
        ele?.status === 0
      );
    }
  };

  const navigateToNextPage = () => {
    console.log(
      "assignedServiceProviderData?.serviceProvider?.serviceProviderId, -> ",
      assignedServiceProviderData
    );
    if (pageNum * pageSize < totalCount) {
      fetchCityMappings(
        customisedSP?.serviceId,
        customisedSP?.providerId,
        customisedSP?.planId,
        pageNum + 1,
        cityMappingFilters ?? {}
      );
      // setPageNum((prevPageNum) => prevPageNum + 1);
    }
  };
  const navigateToPrevPage = () => {
    if (pageNum > 1) {
      fetchCityMappings(
        customisedSP?.serviceId,
        customisedSP?.providerId,
        customisedSP?.planId,
        pageNum - 1,
        cityMappingFilters ?? {}
      );
    }
  };

  return (
    <div className="navigo-appoint-container">
      <div className="navigo-appoint-section-5-cityTableAssignSP">
        <div className="navigo-appoint-section-5-grid-container-cityTableAssignSP">
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTableAssignSP">
            <p>City</p>
            <img
              src={
                (cityMappingFilters?.name ?? "").length > 0
                  ? filterApplied
                  : funnelIcon
              }
              onClick={() => {
                setOpenBackdrop(true);
                setOpenFilter(1);
              }}
            />
            {/* {openFilter === 1 && (
              <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                <Autocomplete
                  multiple
                  id="appointment-dialog-client-code-filter"
                  className="appointment-dialog-client-code-filter-class"
                  disableCloseOnSelect
                  options={[
                    ...(searchText ? [`Select all with "${searchText}"`] : []),
                    ...services.filter((service) =>
                      service.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    ),
                  ]}
                  value={typeFilterValue}
                  onInputChange={(e, value) => {
                    setSearchText(value);
                  }}
                  onChange={(e, v) => {
                    if (v.includes(`Select all with "${searchText}"`)) {
                      const allMatchingOptions = services.filter((service) =>
                        service.name
                          .toLowerCase()
                          .includes(searchText.toLowerCase())
                      );
                      setTypeFilterValue(allMatchingOptions);
                      setTypeFilter(true);
                    } else {
                      setTypeFilterValue(v);
                      setTypeFilter(v.length > 0);
                    }
                  }}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={"Enter the service name"}
                    />
                  )}
                />
              </div>
            )} */}
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTableAssignSP">
            <p>Price</p>
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTableAssignSP">
            <p></p>
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTableAssignSP">
            <p></p>
          </div>
          <div className="navigo-appoint-section-5-grid-container-common-section-cityTableAssignSP">
            <p>Status</p>
            <img
              src={
                (cityMappingFilters?.status ?? []).length > 0
                  ? filterApplied
                  : funnelIcon
              }
              onClick={() => {
                setOpenBackdrop(true);
                setOpenFilter(5);
                // setOpenStatusFilter(true);
              }}
            />
            {openFilter === 5 && (
              <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                <Autocomplete
                  multiple
                  id="appointment-dialog-client-code-filter"
                  className="appointment-dialog-client-code-filter-class"
                  options={allStatusList}
                  value={cityMappingFilters?.status ?? []} //statusFilterValue
                  onChange={(e, v) => {
                    if (v.length > 0) {
                      fetchCityMappings(
                        customisedSP?.serviceId,
                        customisedSP?.providerId,
                        customisedSP?.planId,
                        pageNum,
                        {
                          ...cityMappingFilters,
                          status: v ?? [],
                        }
                      );
                      // setStatusFilterValue(v);
                      // setStatusFilter(true);
                    } else {
                      fetchCityMappings(
                        customisedSP?.serviceId,
                        customisedSP?.providerId,
                        customisedSP?.planId,
                        pageNum,
                        {
                          ...cityMappingFilters,
                          status: [],
                        }
                      );
                      // setStatusFilterValue([]);
                      // setStatusFilter(false);
                    }
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder={"Type status name"} />
                  )}
                />
              </div>
            )}
          </div>
          <div></div>
        </div>
      </div>
      <div className="navigo-appoint-section-6">
        {Boolean((cityMappings?.cityEntities ?? []).length > 0) && (
          <div className="navigo-appoint-bottom-bar">
            <Button
              onClick={() => {
                navigateToPrevPage();
              }}
              disabled={pageNum <= 1 || loading}
            >
              <FontIcon>arrow_left</FontIcon>
            </Button>
            <div style={{ display: "flex", flexDirection: "row" }}>
              Showing&nbsp;
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {totalCount == 0 ? 0 : (pageNum - 1) * pageSize + 1}&nbsp;
              </span>
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                - &nbsp;
                {totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount}
              </span>
              <span>&nbsp;&nbsp;of&nbsp;</span>
              <span>{` ${totalCount}`}</span>
            </div>
            <Button
              onClick={() => {
                navigateToNextPage();
              }}
              disabled={
                loading ||
                pageNum * pageSize > totalCount ||
                (totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount) == totalCount
              }
            >
              <FontIcon>arrow_right</FontIcon>
            </Button>
          </div>
        )}
        <div className="navigo-appoint-section-6-list-cityTableAssignSP">
          {Boolean((tableData?.length ?? 0) > 0) &&
            (tableData ?? []).map((ele, idx) => {
              return (
                <div
                  className="navigo-appoint-section-6-grid-container-cityTableAssignSP"
                  key={ele?.id ?? idx}
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <div className="general-font-class">{ele?.city ?? "-"}</div>

                  <div className="general-font-class">
                    {checkIfPriceAsPerPlanLevel(ele)
                      ? "As per plan level"
                      : "Rs. " + (ele?.price ?? "-")}
                  </div>

                  <div className="general-font-class">
                    <IconButton
                      icon
                      className="text-fields__inline-btn"
                      disabled={mode == "view"}
                      style={{
                        marginBottom: "-15px",
                        marginTop: "-15px",
                      }}
                      onClick={() => {
                        setEditCityPriceDialogFormFields({ price: ele?.price });
                        setEditCityPriceDialog({ open: true, editFor: ele });
                      }}
                    >
                      <OutlineEdit
                        style={{
                          color: "orange",
                        }}
                      />
                    </IconButton>
                  </div>

                  <div></div>

                  <div className="navigo-appoint-section-6-grid-status">
                    {Boolean(ele?.status) && (
                      <Select
                        disabled={mode == "view" || loading}
                        labelId="navigo-appoint-status-select"
                        id="navigo-appoint-status-select-id"
                        value={ele?.status ?? -1}
                        onChange={(e) => {
                          let elem = { ...ele };
                          if (elem?.status) {
                            elem.status = e.target.value;
                            handleUpdateTableData(elem, ele); // 1st param is for new object, and 2nd is for old object
                          }
                        }}
                        label="Status"
                        className={`navigo-dashboard-select-css navigo-status-selector ${`${
                          ele?.status === 1
                            ? "closed-class"
                            : `${
                                ele?.status === 2
                                  ? "invalid-class"
                                  : "progress-class"
                              }`
                        }`}`}
                      >
                        <MenuItem
                          value={1}
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            fontWeight: "600",
                            paddingLeft: "5px",
                            fontFamily: "Montserrat",
                          }}
                          disabled={false}
                        >
                          Active
                        </MenuItem>
                        <MenuItem
                          value={2}
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            fontWeight: "600",
                            paddingLeft: "5px",
                            fontFamily: "Montserrat",
                          }}
                          disabled={false}
                        >
                          Inactive
                        </MenuItem>
                      </Select>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
        {loading && <GlobalSkeletonLoader />}
        {loading === false && (tableData?.length ?? 0) <= 0 && (
          <h3 style={{ width: "100%", textAlign: "center" }}>
            No cities found!
          </h3>
        )}

        {Boolean((cityMappings?.cityEntities ?? []).length > 0) && (
          <div className="navigo-appoint-bottom-bar">
            <Button
              onClick={() => {
                navigateToPrevPage();
              }}
              disabled={pageNum <= 1 || loading}
            >
              <FontIcon>arrow_left</FontIcon>
            </Button>
            <div style={{ display: "flex", flexDirection: "row" }}>
              Showing&nbsp;
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {totalCount == 0 ? 0 : (pageNum - 1) * pageSize + 1}&nbsp;
              </span>
              <span
                style={{
                  color: "#ef7c01",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                - &nbsp;
                {totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount}
              </span>
              <span>&nbsp;&nbsp;of&nbsp;</span>
              <span>{` ${totalCount}`}</span>
            </div>
            <Button
              onClick={() => {
                navigateToNextPage();
              }}
              disabled={
                loading ||
                pageNum * pageSize > totalCount ||
                (totalCount > pageNum * pageSize
                  ? pageNum * pageSize
                  : totalCount) == totalCount
              }
            >
              <FontIcon>arrow_right</FontIcon>
            </Button>
          </div>
        )}
      </div>

      {Boolean(editCityPriceDialog?.open === true) && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog"
          visible={Boolean(editCityPriceDialog?.open === true)}
          focusOnMount={false}
          onHide={() => {
            // setOpenPropCalendarChangesDialog(false);
            // setSPbodyToUpdate(null);
            // setLoading(false);
          }}
          width="700px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left", zIndex: 200 }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-1">
            <h3>{`Enter new price`}</h3>

            <Row>
              <Col xs={12} sm={5} md={4} lg={4}>
                <TextField
                  id="city"
                  name="city"
                  placeholder="City"
                  label="City"
                  disabled={true}
                  value={editCityPriceDialog?.editFor?.city ?? ""}
                />
              </Col>
              <br />
              <Col xs={12} sm={5} md={4} lg={4}>
                <TextField
                  id="price"
                  name="price"
                  label="Price"
                  type="text"
                  placeholder="Enter price"
                  disabled={mode == "view" || loading}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 8) return;
                    if (/^\d+$/.test(e.target.value) || e.target.value === "") {
                      setEditCityPriceDialogFormFields((prev) => ({
                        ...prev,
                        price: value == "" ? "" : Number(value),
                      }));
                    }
                  }}
                  value={editCityPriceDialogFormFields?.price ?? ""}
                />
              </Col>
            </Row>
            <br />
            {/* <div>{`in the default calendar and customised calendar?`}</div> */}
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    // setLoading(false);

                    // setEditCityPriceDialog((prev) => ({
                    //   ...prev,
                    //   editFor: {
                    //     ...(prev?.editFor ?? {}),
                    //     price: value == "" ? "" : Number(value),
                    //   },
                    // }));

                    if (handleUpdateTableData != null) {
                      let elem = { ...(editCityPriceDialog?.editFor ?? {}) };
                      elem.price = editCityPriceDialogFormFields?.price;
                      elem = {
                        ...elem,
                        status: elem?.status ? elem.status : 1,
                      };
                      handleUpdateTableData(elem, editCityPriceDialog?.editFor); // 1st param is for new object, and 2nd is for old object
                    }

                    setEditCityPriceDialogFormFields({});

                    setEditCityPriceDialog({});
                    // setMode(3);
                    // scrollToCitySelectionHeading();
                  }}
                >
                  {"Done"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    // setLoading(false);
                    setEditCityPriceDialogFormFields({});
                    setEditCityPriceDialog({});
                    // props.resetDashboardServiceProvider();
                    // onExit();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}

      {openBackdrop && (
        <div
          className="navigo-appointment-backdrop-class"
          onClick={() => {
            setOpenFilter(0);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default CityTableCustomiseSP;
